import HtmlDisplay from './HtmlDisplay';
import TextDecorator, { TextDecoratorProps } from './TextDecorator';

interface ContentTextRendererProps extends TextDecoratorProps {
  html?: boolean;
  text: string;
}
const ContentTextRenderer: React.FC<ContentTextRendererProps> = (
  props: ContentTextRendererProps
) => {
  const { html = false, text, ...decoratorProps } = props;

  return html ? (
    <HtmlDisplay text={text} />
  ) : (
    <TextDecorator {...decoratorProps} text={text} />
  );
};

export default ContentTextRenderer;
